module.exports = __webpack_public_path__ + "static/3-7be31b075cbd5de1bd38d41a501e400a.jpg";